import React from 'react';
import {t} from 'i18next';
import DataTable from './DataTable';
import LineChart from './LineChart';
import {Typography} from '@mui/material';
import {ProcessingSummaryReportType} from '../ProcessingSummaryTab';

interface ProcessingHistoryProps {
  data: ProcessingSummaryReportType;
}
const ProcessingHistory: React.FC<ProcessingHistoryProps> = ({data}) => {
  return (
    <div className="processing-history">
      <Typography className="typo-text subhead2_size mist-100">
        {t('reports.processingSummary.processingHistoryStage')}
      </Typography>
      <div className="content">
        <LineChart data={data} />
        <DataTable data={data} />
      </div>
    </div>
  );
};

export default ProcessingHistory;
